import { API } from 'utils/api/api'
import {
  GetTrackersListParams,
  TrackersList,
  ControlStatus,
  AuthorizationStatus,
} from '@ketch-com/windlass/dist/dataSentry/v1/trackers/trackers'
import { formatRequestString } from 'utils/helpers/api/queryString'

export const fetchTrackersList = ({
  'start-date': startDate,
  'end-date': endDate,
  'property-codes': propertyCodes,
  'data-system-code': dataSystemCode,
  query,
  offset,
  limit = 7,
  'authorization-status': trackerAuthorizationStatus,
  'control-status': trackerControlStatus,
}: GetTrackersListParams) => {
  return API.get<TrackersList>(
    formatRequestString({
      entityUrl: '/api/v1/data-sentry/trackers/list',
      params: {
        filters: {
          ...(startDate
            ? {
                'start-date': startDate,
              }
            : {}),
          ...(endDate
            ? {
                'end-date': endDate,
              }
            : {}),
          ...(propertyCodes
            ? {
                'property-codes': propertyCodes,
              }
            : {}),
          ...(dataSystemCode
            ? {
                'data-system-code': dataSystemCode,
              }
            : {}),
          ...(query
            ? {
                query,
              }
            : {}),
          ...(offset
            ? {
                offset,
              }
            : {}),
          ...(limit
            ? {
                limit,
              }
            : {}),
          ...(trackerAuthorizationStatus
            ? {
                'authorization-status': trackerAuthorizationStatus,
              }
            : {}),
          ...(trackerAuthorizationStatus === AuthorizationStatus.AUTHORIZED &&
          trackerControlStatus !== ControlStatus.UNSPECIFIED
            ? {
                'control-status': trackerControlStatus,
              }
            : {}),
        },
      },
    }),
  )
}
